module.exports = __webpack_public_path__ + "static/media/bg.9a79df0d.png";